import { SystemConfigurations } from '@/interfaces'

export const isPvScenario = (configuration: SystemConfigurations): boolean =>
  [
    SystemConfigurations.SolarPV,
    SystemConfigurations.SolarPVOnSharedBus,
    SystemConfigurations.SolarPVAndAcCoupledWithWind,
    SystemConfigurations.SolarPVAndWind
  ].includes(configuration)

export const isWindScenario = (configuration: SystemConfigurations): boolean =>
  [
    SystemConfigurations.WindOnShareBus,
    SystemConfigurations.SolarPVAndWind,
    SystemConfigurations.SolarPVAndAcCoupledWithWind
  ].includes(configuration)
